import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import ZkTable from 'vue-table-with-tree-grid'
import VueRouter from 'vue-router'
// import axios from 'axios'
import 'element-ui/lib/theme-chalk/index.css';
// 导入组件
import Login from './pages/Login.vue'
import Admin from './pages/Admin.vue'
import Home from './pages/Home.vue'
import HomeBanner from './pages/HomeBanner.vue'
import HomeRecommend from './pages/HomeRecommend.vue'
import GoodsList from './pages/GoodsList.vue'
import ConsultList from './pages/ConsultList.vue'
import NoticeList from './pages/NoticeList.vue'
import GoodsAdd from './pages/GoodsAdd.vue'
import GoodsEdit from './pages/GoodsEdit.vue'
import CategoryList from './pages/CategoryList.vue'
import OrderList from './pages/OrderList.vue'
import OrderDetail from './pages/OrderDetail.vue'
import AccountList from './pages/AccountList.vue'
import LanguageList from './pages/LanguageList.vue'
import MailNotify from './pages/MailNotify.vue'
import pinia from './store'
import eventBus from "./eventbus/eventbus.js";
Vue.prototype.$evt = eventBus
// this.$ebus.emit('path_change',e)
// this.$ebus.on('path_change',this.event_listen)
// this.$ebus.off('path_change',this.event_listen)
// 配置路由信息
var routes = [
    {
        path: '/',
        redirect: '/admin/goodslist'
    },
    {
        path: '/login',
        component: Login
    },
    {
        path: '/admin',
        component: Admin,
        meta: '管理后台',
        children: [
        {
            path:'home',
            component:Home,
            meta:'首页',
        },
        {
            path:'homebanner',
            component:HomeBanner,
            meta:'首页广告'
        },
        {
            path:'homerecommend',
            component:HomeRecommend,
            meta:'首页推荐'
        },
        {
            path: 'goodslist',
            component: GoodsList,
            meta: '商品管理',
        },
        {
            path: 'goodsadd',
            component: GoodsAdd,
            meta: '新增商品'
        },
        {
            path: 'goodsedit/:id',
            component: GoodsEdit,
            meta: '修改商品'
        },
        {
            path: 'categorylist',
            component: CategoryList,
            meta: '栏目列表'
        },
        {
            path:'consultlist',
            component:ConsultList,
            meta:'咨询列表'
        },
        {
            path:'noticelist',
            component:NoticeList,
            meta:'公告列表'
        },
        {
            path: 'orderlist',
            component: OrderList,
            meta: '订单列表'
        },
        {
            path:'orderdetail',
            component:OrderDetail,
            meta:'订单详情'
        },
        {
            path: 'accountlist',
            component: AccountList,
            meta: '会员列表'
        },
        {
            path:'languagelist',
            component:LanguageList,
            meta:'多语言列表'
        },
        {
            path:'mailnotify',
            component:MailNotify,
            meta:'邮件通知管理'
        }

        ]

    }
]
// 注册全局路由
Vue.use(VueRouter)
Vue.use(ElementUI)
Vue.use(ZkTable)

// 带介入
// https://github.com/MisterTaki/vue-table-with-tree-grid/blob/master/example/Example.vue
// 创建路由实例
var router = new VueRouter({
    routes,
    mode: 'hash'
})

// 导航守卫
router.beforeEach((to, from, next) => {
    // 如果已登录获取跳转到登录页，则继续
    if (localStorage.getItem('token') || to.path === '/login') {
        next()
    } else {
        // 否则跳转到登录页
        next('/login')
    }
})

// 将axios绑定到vue实例的属性$axios上
// Vue.prototype.$axios = axios
// // 每次发请求都加上基本路径
// // axios.defaults.baseURL = '/api'
// axios.defaults.withCredentials = true
// 是否是生产环境
Vue.config.productionTip = false

new Vue({

    // 将路由实例挂载到根实例
    router,
    // 将store挂载到根实例
    pinia,
    render: h => h(App),
}).$mount('#app')

export { router }